export const _detectEnvironment = ({
  hostname,
  baseURL
}: {
  hostname: string;
  baseURL: string;
}): 'local' | 'dev' | 'staging' | 'prod' => {
  if (hostname.includes('localhost')) {
    return 'local';
  }

  if (baseURL.includes('stage')) {
    return 'staging';
  } else if (baseURL.includes('dev')) {
    return 'dev';
  }
  return 'prod';
};

export const detectEnvironment = () =>
  _detectEnvironment({
    hostname: window.location.hostname,
    baseURL: import.meta.env.VITE_REACT_APP_API_ENDPOINT
  });
